import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Slider, OutlinedInput } from '@material-ui/core';
const useStyles = makeStyles({
    sliderInput: {
        width: 23,
        fontSize: 10,
        paddingLeft: 3,
        paddingRight: 3
    },
    input: {
        padding: 2,
        textAlign: 'center'
    },
    sliderRoot: {
        display: 'block',
        width: 260,
        position: 'absolute',
        backgroundColor: '#fff',
        marginTop: 25,
        zIndex: 10,
        border: '1px solid #eee'
    },
    container: {
        '&.MuiGrid-item': {
            width: 23,
            padding: 0
        }
    }
});
export const InputSlider = props => {
    const classes = useStyles();
    const [value, setValue] = React.useState(props.value);
    // Ensure states changes when prop value changes on all re-renders
    React.useEffect(() => { setValue(props.value); }, [props.value]);
    const [displaySlider, setDisplaySlider] = React.useState(false);
    const [sliderFocus, setSliderFocus] = React.useState(false);
    const handleSliderChange = (event, newValue) => {
        props.onChange(newValue);
        setValue(newValue);
    };
    const handleInputChange = (event) => {
        const val = event.target.value === '' ? '' : Number(event.target.value);
        props.onChange(val);
        setValue(val);
    };
    const handleInputFocus = () => {
        if (props.onFocus)
            props.onFocus();
        setDisplaySlider(true);
    };
    const handleSliderFocus = () => {
        if (props.onFocus)
            props.onFocus();
        setDisplaySlider(true);
        setSliderFocus(true);
    };
    const handleInputBlur = () => {
        if (sliderFocus)
            return;
        if (value < 0) {
            setValue(0);
        }
        else if (value > 100) {
            setValue(100);
        }
        setDisplaySlider(false);
        if (props.onBlur)
            props.onBlur();
    };
    const handleSliderBlur = () => {
        setSliderFocus(false);
        setDisplaySlider(false);
        if (props.onBlur)
            props.onBlur();
    };
    return (React.createElement("div", null,
        React.createElement(Grid, { container: true, spacing: 2, alignItems: "center", classes: { root: classes.container } },
            React.createElement(Grid, { item: true, xs: true, style: { padding: 0 } }, displaySlider && (React.createElement(Slider, { value: typeof value === 'number' ? value : 0, onChange: handleSliderChange, onFocus: handleSliderFocus, onBlur: handleSliderBlur, min: props.min, max: props.max, className: classes.sliderRoot, "aria-labelledby": "input-slider" }))),
            React.createElement(Grid, { item: true, style: { padding: 0, paddingLeft: 5, paddingRight: 5 } },
                React.createElement(OutlinedInput, { classes: { root: classes.sliderInput, input: classes.input }, 
                    //disableUnderline={true}
                    value: value, margin: "dense", onChange: handleInputChange, onBlur: handleInputBlur, onFocus: handleInputFocus, inputProps: {
                        step: 1,
                        min: props.min,
                        max: props.max,
                        type: 'text',
                        'aria-labelledby': 'input-slider',
                    } })))));
};
